import { createApp as createClientApp, createSSRApp } from 'vue';
import { createStore } from './stores';
import { createAppI18n } from './i18n';
import { createAppRouter } from './router';
import App from './app.vue';
import { ClientOnly } from './components/client-only';
import {
  languageInjectionKey,
  cookiesInjectionKey,
  i18nInjectionKey,
} from './utils/keys';

export interface AppInitParams {
  language: string;
  cookies: string;
  ssr?: boolean;
}

export function createApp({ language, cookies, ssr = import.meta.env.SSR }: AppInitParams) {
  const app = ssr ? createSSRApp(App) : createClientApp(App);

  app.provide(languageInjectionKey, language);
  app.provide(cookiesInjectionKey, cookies);

  const i18n = createAppI18n(language);

  app.provide(i18nInjectionKey, i18n);
  app.use(i18n);

  const pinia = createStore();

  app.use(pinia);

  if (ssr && typeof window !== 'undefined' && window.__INITIAL_STATE__) {
    pinia.state.value = window.__INITIAL_STATE__;
  }

  const router = createAppRouter({ pinia });

  app.use(router);

  app.component('ClientOnly', ClientOnly);

  return {
    app,
    router,
    pinia,
  };
}
